import styled from 'styled-components';
import { MDBDropdown, MDBDropdownItem } from 'mdbreact';
import { colors } from '../../../theme/style-helpers';

export const StyledMDBDropdown = styled(MDBDropdown)`
  .dropdown-menu {
    padding: 24px;
    background-color: ${colors.LIGHT_GREY} !important;
    cursor: default;

    >div {
      display: grid;
      grid-gap: 24px;
    }
  }
`;

export const DropdownItem = styled(MDBDropdownItem)`
  display: flex !important;
  align-items: center !important;
  padding: 0px !important;
  cursor: pointer;
  color: ${colors.BLACK};

  .icon, .icon path {
    fill: ${colors.BLACK};
  }

  &:disabled {
    color: ${colors.DARK_GREY} !important;

    .icon, .icon path{
      fill: ${colors.DARK_GREY} !important;
    }
  }

  &:hover {
    .icon, .icon path {
      fill: ${colors.BRAND_ORANGE};
    }

    p {
      color: ${colors.BRAND_ORANGE};
    }
  }
`;

export const DropdownItemIcon = styled.div`
  width: 20px;
  height: 20px;
  background: url( ${({ iconSrc }) => iconSrc});
  background-repeat: no-repeat;
  margin: 0;
  margin-right: 8px;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 25px;

  svg {
    margin-right: 8px;
  }
`;

export const DropdownText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
`;
